/**
 * Auth Redux state shape
 */

import type { FieldErrors } from '@/types/shared/form.types';

import type { LoginStep, RegistrationStep, TwoFactorMethod } from './Auth';

export interface CredentialsVerificationThunkData {
  sessionToken: string;
}

export interface AuthState {
  status: 'idle' | 'loading' | 'authenticated' | 'error';
  loginStep: LoginStep;
  userId: string | null;
  error?: string;
  sessionToken?: string;
  registrationStep: RegistrationStep;
  isSubmitting: boolean;
  twoFactorToken?: string;
  registrationToken?: string;
  fieldErrors: FieldErrors;
  twoFactorMethod?: TwoFactorMethod;
  password:string;
  ukek: string;
  decapsKey: string;
  username: string;
  twoFactorMaskedDestination?: string;
  twoFactorExpiresInSeconds?: number;
  maskedEmail?: string;
  maskedPhone?: string;
  forgotPasswordEmailAddress?: string;
  recoveryToken?: string;
  recoveryMaskedPhone?: string;
}

export const initialAuthState: AuthState = {
  loginStep: 'credentials',
  status: 'idle',
  userId: null,
  registrationStep: 'otp',
  isSubmitting: false,
  fieldErrors: {},
  twoFactorMethod: undefined,
  password: '',
  ukek: '',
  decapsKey: '',
  username: '',
  twoFactorMaskedDestination: undefined,
  twoFactorExpiresInSeconds: undefined,
  maskedEmail: undefined,
  maskedPhone: undefined,
  forgotPasswordEmailAddress: undefined,
  recoveryToken: undefined,
  recoveryMaskedPhone: undefined,
};
